export default __webpack_public_path__ + "static/media/moveMolecularWeightMarkers.fb3bb811.gif";